<div style="display: flex; justify-content: center;height: 100%">
    <div>
        <h2>The requested resource is not available</h2>
        <button mat-raised-button (click)="goHome()">Go Home</button>
    </div>
</div>
<br>
<img src="{{url}}/semi_truck.png" style="opacity: 0.4" />